import img1 from '/static/img/aboutUs/ourPartnerships/img1.png'
import img2 from '/static/img/aboutUs/ourPartnerships/img2.png'
import img3 from '/static/img/aboutUs/ourPartnerships/img3.png'
import img4 from '/static/img/aboutUs/ourPartnerships/img4.png'
const ourPartnershipsInfo = {
    title:'our partnerships',
    desc: 'We have a wealth of expertise and multiple partners to better serve our clients.',
    list: [
        {
            id: 1,
            img:img1
        },
        {
            id: 2,
            img:img2
        },
        {
            id: 3,
            img:img3
        },
        {
            id:4,
            img:img4
        },
    ]
}
export default{
    ourPartnershipsInfo
}